<template>
  <div
    v-if="inputLoading"
    class="tw-animate-pulse tw-rounded-full"
    :class="{ 'tw-w-8 tw-h-8 ': !inheritSize }"
  />
  <div v-else class="tw-relative">
    <div
      v-if="avatarUrl && showUserAvatars"
      :class="[
        Classes.AVATAR,
        inheritSize ? 'tw-w-full tw-h-full' : avatarSize,
        'tw-overflow-hidden tw-rounded-full',
      ]"
    >
      <img
        :src="avatarUrl"
        class="tw-object-cover tw-object-center tw-button-transition tw-h-full tw-w-full"
        :alt="user?.name"
      />
    </div>

    <span
      v-else
      :class="[
        Classes.AVATAR,
        inheritSize ? 'tw-w-full tw-h-full' : avatarSize,
        'tw-font-extrabold tw-rounded-full tw-flex tw-items-center tw-justify-center tw-button-transition game-primary-button-color game-link-color game-primary-text tw-pointer-events-none',
      ]"
    >
      <div
        class="tw-absolute tw-inset-0.5 tw-border tw-rounded-full game-primary-button-border-color"
      />
      <span :class="initialSize">{{ userInitials }}</span>
    </span>

    <div
      v-if="showStatus && onlineStatus"
      class="tw-absolute tw-rounded-full tw-border-theme-3"
      :class="[
        Classes.ONLINE_ICON,
        onlineIconStyles,
        onlineStatus ? 'tw-bg-success' : 'tw-bg-grey',
      ]"
    />
  </div>
</template>

<script>
import { isOnlineUser } from '@helpers/utils.js'
import { Settings } from '@config/game.js'
import { toRefs, computed } from 'vue'
import Classes from '@config/css.js'

export default {
  props: {
    user: {
      type: Object,
      default: null,
    },
    size: {
      type: String,
      default: 'md',
      validator: function (value) {
        return ['sm', 'md', 'lg', 'xl'].indexOf(value) !== -1
      },
    },
    inputLoading: {
      type: Boolean,
      default: false,
    },
    inheritSize: {
      type: Boolean,
      default: false,
    },
    showStatus: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const { user, size, inheritSize } = toRefs(props)

    const showUserAvatars = computed(() => Settings.value.showUserAvatars)

    const userInitials = computed(() => {
      if (user.value?.username) {
        return user.value.username.substring(0, 1).toUpperCase()
      }
      return ''
    })
    const avatarUrl = computed(
      () =>
        user.value &&
        user.value.avatar.thumb_100x100?.search('placeholder/') === -1 &&
        user.value.avatar.thumb_100x100
    )
    const avatarSize = computed(() => {
      if (inheritSize.value) {
        return ''
      } else if (size.value === 'sm') {
        return 'tw-w-7 tw-h-7'
      } else if (size.value === 'lg') {
        return 'tw-w-10 tw-h-10'
      } else if (size.value === 'xl') {
        return 'tw-h-20 tw-w-20 sm:tw-h-28 sm:tw-w-28 '
      }
      return 'tw-w-9 tw-h-9'
    })
    const onlineIconStyles = computed(() => {
      if (size.value === 'xl') {
        return 'tw-h-6 tw-w-6 tw-top-2 tw-right-0 tw-border-2'
      }
      return 'tw-h-3 tw-w-3 tw-top-0.5 tw--right-0.5 tw-border-1.5'
    })
    const initialSize = computed(() =>
      size.value === 'xl' ? 'tw-text-h3' : 'tw-text-h6'
    )
    const onlineStatus = computed(() => isOnlineUser(user.value?.date_online))

    return {
      onlineIconStyles,
      showUserAvatars,
      userInitials,
      onlineStatus,
      initialSize,
      avatarSize,
      avatarUrl,
      Classes,
    }
  },
}
</script>
